import { useTranslation } from 'react-i18next';

import { Badge } from '@/common/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/common/components/ui/tooltip';
import { PolicyStatus } from '@/policy/api/PolicyStatus';

export const STATUS_TO_CLASS_MAP: Record<PolicyStatus, string> = {
  PENDING_VALIDATION:
    'rounded-md text-xxs text-utility-blue-light-700 border border-utility-blue-light-200 bg-utility-blue-light-50',
  IN_PROGRESS:
    'rounded-md text-xxs text-utility-gray-700 border border-utility-gray-200 bg-utility-gray-50',
  NOT_COMPLETED:
    'rounded-md text-xxs text-utility-indigo-700 border border-utility-indigo-200 bg-utility-indigo-50',
  COMPLETED:
    'rounded-md text-xxs text-utility-success-700 border border-utility-success-200 bg-utility-success-50',
};

interface Props {
  status: PolicyStatus;
}

export const PolicyStatusBadge = ({ status }: Props) => {
  const { t } = useTranslation();
  const className = STATUS_TO_CLASS_MAP[status];

  if (status === 'IN_PROGRESS') {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge className={className}>{t(status)}</Badge>
          </TooltipTrigger>
          <TooltipContent>
            <p>{t('policy.inProgressTooltip')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return <Badge className={className}>{t(status)}</Badge>;
};
